import { styled } from '@material-ui/core/styles';

export const KeywordsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(1)
}));
